import { createActions } from 'redux-actions';
import { Claim } from '@models/Claim';
import { UploadClaimAdditionalDocumentsParams } from '@apis/ClaimApi';

export type State = {
  claim?: Claim | null;
  additionalDocuments?: File[] | null;
};

export type UserClaimAdditionalDocumentsUploadPayload = UploadClaimAdditionalDocumentsParams;
export type StateUpdatePayload = Partial<State>;

export const { userClaimAdditionalDocumentsUpload, stateUpdate } = createActions(
  'USER_CLAIM_ADDITIONAL_DOCUMENTS_UPLOAD',
  'STATE_UPDATE',
  {
    prefix: 'USER_DASHBOARD_CLAIM_ADDITIONAL_DOCUMENTS',
  },
);
